import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DOCS_TABS, HELP_DEFAULT_SECTION_ID } from './constants';
import { DocsLayout } from './components/DocsLayout';
import { HomeTabContent } from './components/tabs/HomeTabContent';
import { GettingStartedTabContent } from './components/tabs/GettingStartedTabContent';
import { LandingPageGuideTabContent } from './components/tabs/LandingPageGuideTabContent';
import { HelpTabContent } from './components/tabs/HelpTabContent';
import { ReleaseNotesTabContent } from './components/tabs/ReleaseNotesTabContent';
import { ServiceManagementApiTabContent } from './components/tabs/ServiceManagementApiTabContent';

function DocsPage() {
  const navigate = useNavigate();
  const { tabId, sectionId } = useParams<{ tabId?: string; sectionId?: string }>();

  function getTabIndexFromId(id?: string): number {
    if (!id) {
      return 0;
    }

    const index = DOCS_TABS.findIndex(tab => tab.id === id);

    return index >= 0 ? index : 0;
  }

  function getTabRoute(id: string): string {
    if (id === 'help') {
      return `/docs-v2/help/${HELP_DEFAULT_SECTION_ID}`;
    }

    return `/docs-v2/${id}`;
  }

  const currentTab = getTabIndexFromId(tabId);

  useEffect(() => {
    if (!tabId) {
      navigate('/docs-v2/home', { replace: true });
      return;
    }
    if (tabId === 'help' && !sectionId) {
      navigate(getTabRoute(tabId), { replace: true });
    }
  }, [navigate, sectionId, tabId]);

  function handleChange(_event: React.ChangeEvent<{}>, newValue: number) {
    const nextTab = DOCS_TABS[newValue];

    if (!nextTab) {
      return;
    }

    navigate(getTabRoute(nextTab.id));
  }

  const selectedTab = DOCS_TABS[currentTab];
  const tabContentById: Record<string, JSX.Element> = {
    home: <HomeTabContent />,
    'getting-started': <GettingStartedTabContent selectedTabId={selectedTab.id} />,
    'landing-page-guide': (
      <LandingPageGuideTabContent selectedTabId={selectedTab.id} />
    ),
    'service-management-api': <ServiceManagementApiTabContent />,
    help: <HelpTabContent selectedTabId={selectedTab.id} sectionId={sectionId} />,
    'release-notes': <ReleaseNotesTabContent selectedTabId={selectedTab.id} />,
  };
  const tabContent = tabContentById[selectedTab.id];

  return (
    <DocsLayout
      tabs={DOCS_TABS}
      currentTab={currentTab}
      onTabChange={handleChange}
    >
      {tabContent}
    </DocsLayout>
  );
}

export default DocsPage;
